module.exports = __webpack_public_path__ + "static/home-b743c7d36f9678f1ebf61eada488d54a.jpg";